import { useMemo } from 'react';

import { type ListContractTypesQuery, useListContractTypesQuery } from '@/common/graphql';

type AllContractTypes = Omit<
  ListContractTypesQuery['listContractTypes'][number],
  '__typename' | 'defaultGoogleWorkspacePlan'
> & {
  defaultGoogleWorkspacePlan: string | null;
};

export interface UseContractTypePersistenceReturn {
  loading: boolean;
  data: Array<AllContractTypes>;
}

export const useContractTypePersistence = (): UseContractTypePersistenceReturn => {
  const { data: dataRaw, loading } = useListContractTypesQuery({
    fetchPolicy: 'cache-first',
  });

  const data = useMemo(
    () =>
      (dataRaw?.listContractTypes ?? []).map(it => ({
        ...it,
        defaultGoogleWorkspacePlan: it.defaultGoogleWorkspacePlan?.displayName ?? null,
      })),
    [dataRaw?.listContractTypes],
  );

  return { loading, data };
};
